<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="hkiarace/admin/promotion/"
                       data-key="promotions"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.from_time="{value}">
      {{ $parseDate(value, 'dd/MM/yyyy') }}
    </template>
    <template #item.to_time="{value}">
      {{ $parseDate(value, 'dd/MM/yyyy') }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="edit"
                             @click="editItem(item)"></font-awesome-icon>
        </v-col>
        <v-col>
          <font-awesome-icon icon="trash"
                             @click="deleteItem(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'PromotionList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_promotion.name_en'), value: 'base_promotion.name_en', contains: true},
        {text: root.$t('admin_promotion.name_zh'), value: 'base_promotion.name_zh', contains: true},
        {
          text: root.$t('admin_promotion.signup_mode'), value: 'base_promotion.signup_mode',
          options: [
            {text: root.$t('promotion_signup_mode.disabled'), value: -1},
            {text: root.$t('promotion_signup_mode.single_session'), value: 1},
            {text: root.$t('promotion_signup_mode.multi_session'), value: 2},
            {text: root.$t('promotion_signup_mode.multi_series'), value: 3},
          ]
        },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_promotion.name'), value: 'name'},
      {text: root.$t('admin_promotion.from_time'), value: 'from_time'},
      {text: root.$t('admin_promotion.to_time'), value: 'to_time'},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };
    const deleteItem = function (item) {
      if (confirm('Confirm Delete Promotion?')) {
        root.$callAPI('hkiarace/admin/promotion/delete/', {id: item.id}, function () {
          refresh();
        })
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
    }
  }
}
</script>
